import { LitElement, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreFormValidation } from "@slhuicore/form-validation";
import { formElements } from "@slhui/base/form";
import { SlhFormIcons } from "@slhui/form-icons";
import { style } from "./assets/validation.generated-style";

/**
 * It works only with slh-form-validation-observer. It sets the rule for the field.
 *
 * @CustomElement slh-form-validation
 *
 * @cssprop --slh-default-font-family - Validation error message font family.
 * @cssprop --slh-base-xs-font-size - Validation error message font size.
 * @cssprop --slh-base-semi-bold-font-weight - Validation error message weight.
 * @cssprop --slh-base-xxs-line-height - Validation error message height.
 * @cssprop --slh-color-error-darken - Validation error message font color.
 */
@customElement("slh-form-validation")
export default class SlhFormValidation extends SlhCoreFormValidation(
  LitElement
) {
  static styles = style;

  // eslint-disable-next-line class-methods-use-this
  getFormElements(): string[] {
    return formElements;
  }

  // eslint-disable-next-line class-methods-use-this
  renderErrorIcon(): TemplateResult {
    return SlhFormIcons.renderErrorIcon();
  }
}
